import { BounceContainer } from '@components/BounceContainer/BounceContainer'
import { RainbowAvatar } from '@components/RainbowAvatar/RainbowAvatar'
import { shortAddress } from '@plug-core/utils/shortAddress'
import { Contact } from '@plug-core/interfaces/common'
import { Box, ListItem, ListItemAvatar, ListItemText, Paper } from '@mui/material'
import React from 'react'
import addressMatcher, { AddressType } from '@plug-core/utils/addressMatcher'
import { getChainIcon } from '@plug-core/utils/getChainIcon'

interface IProps {
  contact: Contact
  onClick?: (contact: Contact) => void
}

const getLogoForAddressType = (address: AddressType) => {
  switch (address) {
    case AddressType.AccountId:
    case AddressType.PrincipalId:
      return getChainIcon('icp')
    default:
      return getChainIcon(AddressType[address].toLowerCase())
  }
}

export const ContactListItem = ({ contact, onClick }: IProps) => {
  const addressType = addressMatcher(contact.address)

  return (
    <BounceContainer>
      <Paper
        sx={{ height: 72 }}
        elevation={0}
        component={ListItem}
        onClick={() => onClick?.(contact)}
      >
        <ListItemAvatar>
          <Box sx={{ position: 'relative', width: 40, height: 40 }}>
            <RainbowAvatar size={40} avatar={contact.avatar || '🚀'} />
            {addressType !== AddressType.Invalid && (
              <img
                src={getLogoForAddressType(addressType)}
                alt={`${addressType} logo`}
                style={{
                  position: 'absolute',
                  bottom: -6,
                  left: 27,
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                }}
              />
            )}
          </Box>
        </ListItemAvatar>

        <ListItemText
          primary={contact.name || 'account1'}
          secondary={shortAddress(contact.address, { leftSize: 16 })}
        />
      </Paper>
    </BounceContainer>
  )
}
